import {Client} from "../../API";
import {onUpdateClient} from "../../graphql/subscriptions";
import {getClient} from "../../graphql/queries";

import {ActiveRecord} from "./ActiveRecord";

import {ClientDataUtils} from "../../shared/utils/clientDataUtils";
import {ClientInApp} from "../../shared/types/SubscriptionTypes";
import {BasicDataSourceDeps} from "../../platform/services/types/DataSourceDependencies";
import {queryGqlApi} from "../../graphql/queryGqlApi";

export class ClientActiveRecord extends ActiveRecord<Client, ClientInApp> {
    id: string;
    deps: BasicDataSourceDeps;
    _modelName = 'Client';
    _subscriptionGQL = onUpdateClient;

    constructor(deps: BasicDataSourceDeps, id: string) {
        super();
        this.deps = deps;
        this.id = id;
    }

    getWsClient() {
        return this.deps.dataClientService.getWsClientByKey('main');
    };

    async loadGQLFetch(): Promise<Client> {
        const clientDb = await queryGqlApi(
            getClient,
            {
                id: this.id
            },
            this.deps.dataClientService,
            this.deps.authService,
            'main'
        );
        return clientDb;
    }

    mapServerResponseToLocalRow(clientDB: Client) {
        return ClientDataUtils.parseRawClientData(clientDB);
    }
}
